export const FIELD_BUILDER_PANE_WIDTH = 480;

export const FIELD_BUILDER_PANE_COLLAPSED_WIDTH = 375;
